import React from 'react';
import IPage from '../../interfaces/page'

const CapabilitiesPage: React.FunctionComponent<IPage> = () => {
    return <div>Capabilities Page</div>
}

export default CapabilitiesPage